module.exports = __webpack_public_path__ + "assets/Retina-BoldItalic.2713405da6099e8c9b0bc98734f758cf.woff2";